<template>
  <div
    class="sidebar"
    :class="{ expanded: menuOpen }"
    @mouseover="menuOpen = true"
    @mouseleave="menuOpen = false"
  >
    <div class="search-block">
      <span class="icon-wrap">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
      </span>
      <input
        v-if="menuOpen"
        v-model="searchSong"
        class="search-input"
        @input="updateSearchTerm"
        placeholder="Chercher une chanson..."
        autofocus
      />
    </div>

    <nav class="nav">
      <div class="artist-group" v-if="menuOpen">
        <span class="artist-label">Ballzzy</span>
      </div>
      <a
        v-for="link in ballzzyLinks"

        :key="link.label"
        :href="menuOpen ? link.url : null"
        target="_blank"
        class="nav-item"
      >
        <span :class="link.class" v-html="link.icon"></span>
        <span v-if="menuOpen" class="nav-label">{{ link.label }}</span>
      </a>

      <div class="divider" />

      <div class="artist-group" v-if="menuOpen">
        <span class="artist-label">Belle Demoiselle</span>
      </div>
      <a
        v-for="link in belleLinks"
        :key="link.label"
        :href="menuOpen ? link.url : null"
        target="_blank"
        class="nav-item"
      >
        <span :class="link.class" v-html="link.icon"></span>
        <span v-if="menuOpen" class="nav-label">{{ link.label }}</span>
      </a>

      <div class="divider" />

      <a
        v-for="link in generalLinks"
        :key="link.label"
        :href="menuOpen ? link.url : null"
        target="_blank"
        class="nav-item"
      >
        <span class="icon-wrap" v-html="link.icon"></span>
        <span v-if="menuOpen" class="nav-label">{{ link.label }}</span>
      </a>
    </nav>

    <div class="sidebar-footer" v-if="!menuOpen">
      <div class="collapse-dots"><span /><span /><span /></div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

const ICONS = {
  spotify: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 512 512"><path d="M256 0C114.7 0 0 114.7 0 256s114.7 256 256 256 256-114.7 256-256S397.3 0 256 0" style="fill:#1ed760"/><path d="M419.7 230.3c-5.4 0-8.7-1.3-13.3-4-73.5-43.9-204.9-54.4-290-30.7-3.7 1-8.4 2.7-13.3 2.7-13.6 0-24.1-10.6-24.1-24.4 0-14 8.7-22 18-24.7 36.3-10.6 77-15.7 121.3-15.7 75.4 0 154.3 15.7 212 49.3 8.1 4.6 13.3 11 13.3 23.3.1 14.2-11.3 24.2-23.9 24.2m-32 78.7c-5.4 0-9-2.4-12.7-4.3-64.5-38.2-160.7-53.6-246.3-30.3-5 1.3-7.6 2.7-12.3 2.7-11 0-20-9-20-20s5.4-18.4 16-21.4c28.7-8.1 58-14 101-14 67 0 131.7 16.6 182.7 47 8.4 5 11.7 11.4 11.7 20.3-.2 11-8.8 20-20.1 20m-27.8 67.7c-4.3 0-7-1.3-11-3.7-64.4-38.8-139.4-40.5-213.4-25.3-4 1-9.3 2.7-12.3 2.7-10 0-16.3-7.9-16.3-16.3 0-10.6 6.3-15.7 14-17.3 84.5-18.7 170.9-17 244.6 27 6.3 4 10 7.6 10 17s-7.2 15.9-15.6 15.9"/></svg>`,
  deezer: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" id="Layer_1" x="0" y="0" version="1.1" viewBox="-0.02 0 277.13 277.12"><style id="style2" type="text/css">.st0{fill:#a238ff}</style><g id="g10" transform="translate(-13.9)"><path id="path4" d="M21.9 115.7c4.4 0 8-14.5 8-32.4s-3.6-32.4-8-32.4-8 14.5-8 32.4 3.6 32.4 8 32.4" class="st0"/><path id="path6" d="M256.8 18c-4.2 0-7.9 9.3-10.5 24.2C242.1 16.7 235.4 0 227.8 0c-9 0-16.9 23.5-20.6 57.7C203.5 32.9 198 17 191.9 17c-8.6 0-16 31.2-18.7 74.7-5.1-22.3-12.5-36.3-20.7-36.3s-15.6 14-20.7 36.3C129 48.2 121.7 17 113 17c-6.2 0-11.7 15.9-15.3 40.8C94 23.5 86.2 0 77.1 0c-7.6 0-14.4 16.7-18.5 42.3C56 27.4 52.3 18 48.1 18 40.3 18 34 50.5 34 90.5s6.3 72.4 14.1 72.4c3.2 0 6.2-5.5 8.5-14.7 3.7 33.8 11.5 57 20.5 57 7 0 13.2-13.9 17.4-35.9 2.9 41.8 10.1 71.5 18.5 71.5 5.3 0 10.1-11.8 13.7-30.9 4.3 39.5 14.2 67.2 25.8 67.2s21.5-27.7 25.8-67.2c3.6 19.1 8.4 30.9 13.7 30.9 8.4 0 15.6-29.7 18.5-71.5 4.2 22 10.4 35.9 17.4 35.9 9 0 16.8-23.2 20.5-57 2.4 9.2 5.3 14.7 8.5 14.7 7.8 0 14.1-32.4 14.1-72.4-.2-40-6.5-72.5-14.2-72.5" class="st0"/><path id="path8" d="M283 115.7c4.4 0 8-14.5 8-32.4s-3.6-32.4-8-32.4-8 14.5-8 32.4 3.6 32.4 8 32.4" class="st0"/></g></svg>`,
  appleMusic: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 512 512"><linearGradient id="a" x1="256" x2="256" y1="2.978" y2="501.959" gradientTransform="matrix(1 0 0 -1 0 513)" gradientUnits="userSpaceOnUse"><stop offset="0" style="stop-color:#fa233b"/><stop offset="1" style="stop-color:#fb5c74"/></linearGradient><path d="M512 160.2v-18.3c0-5.1-.1-10.3-.2-15.4-.3-11.2-1-22.5-3-33.6-2-11.3-5.3-21.7-10.5-32-5.1-10.1-11.8-19.2-19.8-27.2S461.3 19 451.3 13.9c-10.2-5.2-20.7-8.5-32-10.5-11.1-2-22.4-2.7-33.6-3-5.1-.1-10.3-.2-15.4-.2H141.9c-5.1 0-10.3.1-15.4.2-11.2.3-22.5 1-33.6 3-11.3 2-21.7 5.3-32 10.5C50.8 19 41.6 25.7 33.7 33.7s-14.8 17-19.9 27.1C8.5 71 5.2 81.5 3.2 92.8c-2 11.1-2.7 22.4-3 33.6-.1 5.1-.2 10.3-.2 15.4v228.3c0 5.1.1 10.3.2 15.4.3 11.2 1 22.5 3 33.6 2 11.3 5.3 21.7 10.5 32 5.1 10.1 11.8 19.2 19.8 27.2s17.2 14.7 27.2 19.8c10.2 5.2 20.7 8.5 32 10.5 11.1 2 22.4 2.7 33.6 3 5.1.1 10.3.2 15.4.2H370c5.1 0 10.3-.1 15.4-.2 11.2-.3 22.5-1 33.6-3 11.3-2 21.7-5.3 32-10.5 10.1-5.1 19.3-11.8 27.2-19.8s14.7-17.2 19.8-27.2c5.2-10.2 8.5-20.7 10.5-32 2-11.1 2.7-22.4 3-33.6.1-5.1.2-10.3.2-15.4v-18.3z" style="fill-rule:evenodd;clip-rule:evenodd;fill:url(#a)"/><path d="M362 78.2c-1.2.1-12.2 2.1-13.6 2.3l-152.2 30.7h-.1c-4 .8-7.1 2.2-9.5 4.3-2.9 2.4-4.5 5.9-5.1 9.9-.1.9-.3 2.6-.3 5.1V321c0 4.5-.4 8.8-3.4 12.5s-6.7 4.8-11.1 5.7c-3.3.7-6.6 1.3-9.9 2-12.6 2.5-20.8 4.3-28.2 7.1-7.1 2.7-12.4 6.2-16.6 10.7-8.4 8.8-11.8 20.7-10.6 31.8 1 9.5 5.3 18.6 12.6 25.3 5 4.6 11.2 8 18.5 9.5 7.6 1.5 15.7 1 27.5-1.4 6.3-1.3 12.2-3.2 17.8-6.6 5.5-3.3 10.3-7.6 14-13 3.7-5.3 6.1-11.3 7.5-17.6 1.4-6.5 1.7-12.4 1.7-18.9v-165c0-8.8 2.5-11.2 9.6-12.9 0 0 126.5-25.5 132.4-26.7 8.2-1.6 12.1.8 12.1 9.4v112.8c0 4.5 0 9-3.1 12.7-3 3.7-6.7 4.8-11.1 5.7-3.3.7-6.6 1.3-9.9 2-12.6 2.5-20.8 4.3-28.2 7.1-7.1 2.7-12.4 6.2-16.6 10.7-8.4 8.8-12.1 20.7-10.9 31.8 1 9.5 5.6 18.6 12.9 25.3 5 4.6 11.2 7.9 18.5 9.4 7.6 1.5 15.7 1 27.5-1.4 6.3-1.3 12.2-3.2 17.8-6.5 5.5-3.3 10.3-7.6 14-13 3.7-5.3 6.1-11.3 7.5-17.6 1.4-6.5 1.4-12.4 1.4-18.9V91.7c-.1-8.8-4.7-14.2-12.9-13.5" style="fill-rule:evenodd;clip-rule:evenodd;fill:#fff"/></svg>`,
  youtubeMusic: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 176 176"><circle cx="88" cy="88" r="88" fill="red"/><path fill="#FFF" d="M88 46c23.1 0 42 18.8 42 42s-18.8 42-42 42-42-18.8-42-42 18.9-42 42-42m0-4c-25.4 0-46 20.6-46 46s20.6 46 46 46 46-20.6 46-46-20.6-46-46-46"/><path fill="#FFF" d="m72 111 39-24-39-22z"/></svg>`,
  instagram: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 512 512"><radialGradient id="a" cx="-167.747" cy="-6.147" r="255.952" gradientTransform="matrix(0 -1.982 -1.8439 0 124.667 218.883)" gradientUnits="userSpaceOnUse"><stop offset="0" style="stop-color:#fd5"/><stop offset=".1" style="stop-color:#fd5"/><stop offset=".5" style="stop-color:#ff543e"/><stop offset="1" style="stop-color:#c837ab"/></radialGradient><path d="M256.1.1C149.2.1 118 .2 111.9.7 89.9 2.5 76.3 6 61.4 13.4 50 19.1 40.9 25.6 32 34.9 15.8 51.8 5.9 72.5 2.4 97.2.7 109.2.2 111.6.1 172.8V256c0 106.8.1 138 .6 144.1 1.8 21.3 5.1 34.8 12.2 49.5 13.5 28.1 39.4 49.2 69.9 57.1 10.6 2.7 22.2 4.2 37.2 4.9 6.3.3 71 .5 135.6.5s129.3-.1 135.5-.4c17.3-.8 27.4-2.2 38.5-5 30.7-7.9 56.1-28.7 69.9-57.2 7-14.3 10.5-28.3 12.1-48.5.3-4.4.5-74.7.5-144.9s-.2-140.4-.5-144.8c-1.6-20.6-5.1-34.4-12.3-49-5.9-12-12.4-20.9-21.9-30-16.9-16.2-37.6-26-62.3-29.6C403.1 1 400.8.5 339.6.4h-83.5z" style="fill:url(#a)"/><radialGradient id="b" cx="278.405" cy="166.356" r="255.952" gradientTransform="matrix(.1739 .8687 3.5818 -.7172 -730.042 -85.605)" gradientUnits="userSpaceOnUse"><stop offset="0" style="stop-color:#3771c8"/><stop offset=".128" style="stop-color:#3771c8"/><stop offset="1" style="stop-color:#60f;stop-opacity:0"/></radialGradient><path d="M256.1.1C149.2.1 118 .2 111.9.7 89.9 2.5 76.3 6 61.4 13.4 50 19.1 40.9 25.6 32 34.9 15.8 51.8 5.9 72.5 2.4 97.2.7 109.2.2 111.6.1 172.8V256c0 106.8.1 138 .6 144.1 1.8 21.3 5.1 34.8 12.2 49.5 13.5 28.1 39.4 49.2 69.9 57.1 10.6 2.7 22.2 4.2 37.2 4.9 6.3.3 71 .5 135.6.5s129.3-.1 135.5-.4c17.3-.8 27.4-2.2 38.5-5 30.7-7.9 56.1-28.7 69.9-57.2 7-14.3 10.5-28.3 12.1-48.5.3-4.4.5-74.7.5-144.9s-.2-140.4-.5-144.8c-1.6-20.6-5.1-34.4-12.3-49-5.9-12-12.4-20.9-21.9-30-16.9-16.2-37.6-26-62.3-29.6C403.1 1 400.8.5 339.6.4h-83.5z" style="fill:url(#b)"/><path d="M256 67c-51.3 0-57.8.2-77.9 1.1s-33.9 4.1-45.9 8.8c-12.4 4.8-23 11.3-33.5 21.8s-17 21.1-21.8 33.5c-4.7 12-7.9 25.8-8.8 45.9-.9 20.2-1.1 26.6-1.1 77.9s.2 57.8 1.1 77.9 4.1 33.9 8.8 45.9c4.8 12.4 11.3 23 21.8 33.5s21 17 33.5 21.8c12 4.7 25.8 7.9 45.9 8.8 20.2.9 26.6 1.1 77.9 1.1s57.8-.2 77.9-1.1 33.9-4.1 45.9-8.8c12.4-4.8 23-11.3 33.5-21.8s17-21.1 21.8-33.5c4.6-12 7.8-25.8 8.8-45.9.9-20.2 1.1-26.6 1.1-77.9s-.2-57.8-1.1-77.9-4.1-33.9-8.8-45.9c-4.8-12.4-11.3-23-21.8-33.5s-21-17-33.5-21.8c-12-4.7-25.8-7.9-45.9-8.8-20.2-.9-26.6-1.1-77.9-1.1m-17 34.1h17c50.5 0 56.4.2 76.4 1.1 18.4.8 28.4 3.9 35.1 6.5 8.8 3.4 15.1 7.5 21.7 14.1s10.7 12.9 14.1 21.7c2.6 6.7 5.7 16.7 6.5 35.1.9 19.9 1.1 25.9 1.1 76.4s-.2 56.4-1.1 76.4c-.8 18.4-3.9 28.4-6.5 35.1-3.4 8.8-7.5 15.1-14.1 21.7s-12.9 10.7-21.7 14.1c-6.7 2.6-16.7 5.7-35.1 6.5-19.9.9-25.9 1.1-76.4 1.1s-56.5-.2-76.4-1.1c-18.4-.9-28.4-3.9-35.1-6.5-8.8-3.4-15.1-7.5-21.7-14.1s-10.7-12.9-14.1-21.7c-2.6-6.7-5.7-16.7-6.5-35.1-.9-19.9-1.1-25.9-1.1-76.4s.2-56.4 1.1-76.4c.8-18.4 3.9-28.4 6.5-35.1 3.4-8.8 7.5-15.1 14.1-21.7s12.9-10.7 21.7-14.1c6.7-2.6 16.7-5.7 35.1-6.5 17.4-.9 24.2-1.1 59.4-1.1m117.9 31.4c-12.5 0-22.7 10.1-22.7 22.7 0 12.5 10.2 22.7 22.7 22.7s22.7-10.2 22.7-22.7-10.2-22.8-22.7-22.7M256 159c-53.6 0-97.1 43.5-97.1 97.1s43.5 97 97.1 97 97-43.4 97-97-43.4-97.1-97-97.1m0 34c34.8 0 63 28.2 63 63s-28.2 63-63 63-63-28.2-63-63 28.2-63 63-63" style="fill:#fff"/></svg>`,
  web: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 010 20M12 2a15.3 15.3 0 000 20"/></svg>`,
  poop: `<?xml version="1.0" encoding="utf-8"?><!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools --><svg width="800px" height="34px" viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="" preserveAspectRatio="xMidYMid meet"><path d="M118.89 75.13a15.693 15.693 0 0 0-7-7.33a22.627 22.627 0 0 0-6-2.63c1.53-5.6-.64-10.06-3.69-13.39c-4.51-4.88-9.2-5.59-9.2-5.59c1.62-3.07 2.11-6.61 1.36-10c-.77-3.69-3.08-6.86-6.36-8.72c-3.1-1.83-6.92-2.73-10.84-3.47c-1.88-.34-9.81-1.45-13.1-6c-2.65-3.69-2.73-10.33-3.45-12.32s-3.38-1.15-6.23.76C51.05 8.7 44.15 15.83 41.49 23a24.6 24.6 0 0 0-1.28 13.89c-2.14.35-4.23.97-6.21 1.85c-.16 0-.32.1-.49.17c-3 1.24-9.43 7-10 15.85c-.21 3.13.19 6.26 1.17 9.24c-2.19.57-4.3 1.43-6.26 2.57c-2.29.98-4.38 2.38-6.15 4.13c-1.95 2.41-3.37 5.2-4.15 8.2a27.594 27.594 0 0 0 2 19.77c1.8 3.47 4.06 6.67 6.74 9.52c8.55 8.79 23.31 12.11 35 14c14.19 2.34 29.05 1.52 42.33-4c19.92-8.22 25.22-21.44 26-25.17c1.73-8.25-.39-16.02-1.3-17.89z" fill="#885742"></path><path d="M87.45 92.89c-1.57.8-3.17 1.52-4.78 2.16c-1.08.43-2.17.82-3.27 1.17c-1.1.36-2.21.67-3.33 1c-2.24.56-4.52.97-6.82 1.21c-1.74.19-3.5.28-5.25.28c-4.62 0-9.22-.65-13.67-1.91l-1.46-.44a55.12 55.12 0 0 1-7.15-2.84l-1.39-.69a22.722 22.722 0 0 0 12.72 15.31c3.43 1.59 7.17 2.4 10.95 2.38c3.82.03 7.6-.75 11.09-2.31a21.868 21.868 0 0 0 12.58-15.44l-.22.12z" fill="#35220b"></path><path d="M85.19 90c-7 1.23-14.09 1.82-21.19 1.77c-7.1.04-14.19-.55-21.19-1.77a2.16 2.16 0 0 0-2.53 2.54v.25A51.578 51.578 0 0 0 64 98.66c1.75 0 3.51-.09 5.25-.28c2.3-.24 4.58-.65 6.82-1.21c1.12-.28 2.23-.59 3.33-1s2.19-.74 3.27-1.17c1.62-.67 3.21-1.39 4.78-2.16l.22-.12l.06-.27c.17-1.19-.66-2.29-1.86-2.46a2.22 2.22 0 0 0-.68.01z" fill="#ffffff"></path><g><circle cx="80.13" cy="69.49" r="12.4" fill="#ffffff"></circle><ellipse cx="80.13" cy="69.49" rx="5.73" ry="5.82" fill="#35220b"></ellipse><circle cx="47.87" cy="69.49" r="12.4" fill="#ffffff"></circle><ellipse cx="47.87" cy="69.49" rx="5.73" ry="5.82" fill="#35220b"></ellipse></g></svg>`,
};

export default {
  data() {
    return {
      menuOpen: false,
      searchSong: "",
      ballzzyLinks: [
        {
          label: "Spotify",
          url: "https://open.spotify.com/intl-fr/artist/57s3WOuEzD9ueruw3QKrYU?si=In7yJiw_QUm9ZrUsU1LbHQ",
          class: "icon-wrap",
          icon: ICONS.spotify,
        },
        {
          label: "Deezer",
          url: "https://deezer.page.link/YkXXz2ge6mAFZzxr8",
          class: "icon-wrap-no",
          icon: ICONS.deezer,
        },
        {
          label: "Apple Music",
          url: "https://music.apple.com/us/artist/ballzzy/1744180258",
          class: "icon-wrap-no",
          icon: ICONS.appleMusic,
        },
        {
          label: "YouTube Music",
          url: "https://music.youtube.com/channel/UCKG__wUG1zCoLE8N0eOedCA",
          class: "icon-wrap",
          icon: ICONS.youtubeMusic,
        },
      ],
      belleLinks: [
        {
          label: "Spotify",
          url: "https://open.spotify.com/intl-fr/artist/1ihPL4eI2ThTMGhWiPVef0?si=wLLwpo2XS7WxKz8l3zOY6g",
          icon: ICONS.spotify,
          class: "icon-wrap",
        },
        {
          label: "Deezer",
          url: "https://deezer.page.link/TTWMro5dUvEUFU9W6",
          icon: ICONS.deezer,
          class: "icon-wrap-no",
        },
        {
          label: "Apple Music",
          url: "https://music.apple.com/us/album/freedom-single/1819238771",
          icon: ICONS.appleMusic,
          class: "icon-wrap-no",
        },
        {
          label: "YouTube Music",
          url: "https://music.youtube.com/channel/UCs1nDYqlLgj4PFUDF5A_pSQ",
          icon: ICONS.youtubeMusic,
          class: "icon-wrap",
        },
      ],
      generalLinks: [
        {
          label: "Brutal Fekal",
          url: "https://brutalfekal.fr/",
          icon: ICONS.poop,
          class: "icon-wrap-no",
        },
        {
          label: "Instagram",
          url: "https://www.instagram.com/marius_bbs/",
          icon: ICONS.instagram,
          class: "icon-wrap-no",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["search"]),
  },
  methods: {
    ...mapActions(["updateSearch"]),
    updateSearchTerm() {
      this.updateSearch(this.searchSong);
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500&display=swap");

* {
  box-sizing: border-box;
}

.sidebar {
  font-family: "DM Sans", sans-serif;
  display: flex;
  flex-direction: column;
  gap: 0;
  background: #f33535;
  border-right: 1px solid #ffa6a6;
  /*height: 100%;*/
  bottom: 0;
  width: 64px;
  overflow: hidden;
  transition: width 0.28s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 24px 0 20px;
  z-index: 100;
  top: 90px;
}

.sidebar.expanded {
  width: 220px;
}

/* ── Search ── */
.search-block {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 12px;
  margin-bottom: 28px;
}

.search-input {
  flex: 1;
  background: #f1f1f1;
  border: 1px solid #2a2a2a;
  border-radius: 8px;
  color: #000000;
  font-family: inherit;
  font-size: 13px;
  outline: none;
  padding: 7px 10px;
  transition: border-color 0.2s;
  min-width: 0;
}

.search-input::placeholder {
  color: #555;
}

.search-input:focus {
  border-color: #444;
}

/* ── Nav ── */
.nav {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0;
  scrollbar-width: none;
}

.nav::-webkit-scrollbar {
  display: none;
}

.artist-group {
  padding: 6px 16px 4px;
}

.artist-label {
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #484848;
}

.divider {
  margin: 10px 12px;
  border-top: 1px solid #1c1c1c;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 9px 14px;
  text-decoration: none;
  color: #ffffff;
  transition:
    background 0.15s,
    color 0.15s;
  white-space: nowrap;
}

.nav-item:hover {
  background: #1a1a1a;
  color: #e8e8e8;
}

/* ── Icons ── */
.icon-wrap {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  background: #e4e4e4;
  border: 1px solid #ffffff;
  color: inherit;
  transition: border-color 0.15s;
}
/* ── Icons ── */
.icon-wrap-no {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  background: none;
  color: inherit;
  transition: border-color 0.15s;
}

.nav-item:hover .icon-wrap {
  border-color: #333;
}

.icon-wrap svg {
  width: 16px;
  height: 16px;
}

/* ── Label ── */
.nav-label {
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0.01em;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ── Footer dots (collapsed hint) ── */
.sidebar-footer {
  display: flex;
  justify-content: center;
  margin-top: auto;
  padding-top: 8px;
}

.collapse-dots {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
}

.collapse-dots span {
  display: block;
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: #333;
}

/* ── Mobile ── */
@media (max-width: 768px) {
  .sidebar {
    width: 52px;
  }
  .sidebar.expanded {
    width: 200px;
  }
  .icon-wrap {
    width: 30px;
    height: 30px;
  }
  .icon-wrap svg {
    width: 14px;
    height: 14px;
  }
  .icon-wrap-no {
    width: 30px;
    height: 30px;
  }
}
</style>
